import React from "react";
import { useFormContext } from 'react-hook-form';
import { Image } from 'react-bootstrap';
import { CARD_BACKGROUND_TYPE, ImageDomain } from "config/CustomEnums";
import QrCode from '../../assets/images/level/qrCode.png';
import { getBackgroundImage } from "./utils";
import './LevelLandscape.scss';

const getLandscapeConfig = (
  isNormal,
  isApp,
  webAppIsMobile,
) => {
  if (isNormal) {
    return {
      containerClassName: "",
      imageClassName: "",
    };
  };
  if (isApp) {
    return {
      containerClassName: "level-landscape-app-container",
      imageClassName: "level-landscape-app-image",
    };
  };
  if (webAppIsMobile) {
    return {
      containerClassName: "level-landscape-webapp-mobile-container",
      imageClassName: "level-landscape-webapp-mobile-image",
    };
  };
  return {
    containerClassName: "level-landscape-webapp-desktop-container",
    imageClassName: "level-landscape-webapp-desktop-image",
  };
}


const LevelLandscape = ({
  isNormal = false,
  isApp = false,
  webAppIsMobile = false,
}) => {
  const { watch } = useFormContext();

  const foregroundColorField = "displayForegroundElementColor";
  const backgroundTypeField = "membershipCardBackgroundType";
  const backgroundColorField = "displayMembershipCardBackgroundColor";
  const appBackgroundImageField = "cardLandscapeBackgroundImageInApp";
  const webappBackgroundImageField = "cardLandscapeBackgroundImageInWeb";

  const watchForegroundColor = watch(foregroundColorField);
  const watchBackgroundType = watch(backgroundTypeField);
  const watchBackgroundColor = watch(backgroundColorField);
  const watchAppBackgroundImage = watch(appBackgroundImageField);
  const watchWebappBackgroundImage = watch(webappBackgroundImageField);

  const useImage = watchBackgroundType === CARD_BACKGROUND_TYPE.image;
  const landscapeConfig = getLandscapeConfig(isNormal, isApp, webAppIsMobile);
  const backgroundImage = getBackgroundImage(
    watchAppBackgroundImage,
    watchWebappBackgroundImage,
    isNormal,
    isApp
  );

  return (
    <div className={`level-landscape-container ${landscapeConfig.containerClassName}`} >
      <div className="level-landscape-background-image-container">
        {
          useImage
            ? <Image className={`level-landscape-image ${landscapeConfig.imageClassName}`} src={backgroundImage ? `${ImageDomain}${backgroundImage}` : ''} />
            : null
        }
      </div>
      <div
        className="level-landscape-content-container"
        style={{
          color: `#${watchForegroundColor}`,
          ...(
            useImage
              ? null
              : { background: `#${watchBackgroundColor}` }
          )
        }}
      >
        <div className="level-landscape-header">
          <div>
            <div className="headline" >Peter Chan</div>
            <div className="body-3">Level Name</div>
          </div>
          <div
            className="qrcode-icon"
            style={{ backgroundColor: `#${watchForegroundColor}` }}
          >
            <img alt="icon" src={QrCode} />
          </div>
        </div>

        <div className="level-landscape-content">
          <div className="subheading">Spend HK$4,500 more</div>
          <div className="level-landscape-spend-more-description tag-menu-1">to upgrade to Level name</div>
          <div className="progress-bar-below" />
          <div className="progress-bar-top" style={{ backgroundColor: `#${watchForegroundColor}` }} />
        </div>
      </div>
    </div >
  )
}

export default LevelLandscape;
